module.exports = __webpack_public_path__ + "img/st-asuransi.fd515fef.jpg";